import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";
import { NumericFormat } from "react-number-format";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Autocomplete,
  TextField,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  MoreVert,
  AddCircle,
  RemoveCircle,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  Close,
  SignalCellularNullRounded,
  Upload,
  List,
  GridView,
  InsertDriveFile,
  InsertPhoto,
} from "@mui/icons-material";
import {
  get_customer_detail,
  get_customer_contact,
  get_inventory_by_customer,
  create_orders_admin,
  validate_cart_admin,
  get_class,
  get_shipping_method_admin,
  get_merchandiser,
  get_sales_rep,
  add_address_admin,
  get_country,
  get_upload_file,
  get_color_name,
  get_state,
  validate_state,
  output_echo,
  get_inventory_by_customer_children,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";
import ShirtIcon from "../../assets/images/shirt.svg";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";
import { useDropzone } from "react-dropzone";

export default function CreateOrder() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const OrderProductRef = useRef(null);

  const withdrawTextFieldProps = {
    name: "amount",
    placeholder: "Enter Your Withdraw Amount",
    className: "theForm",
  };

  const [displayFloat, setDisplayFloat] = useState(false);

  const [colorData, setColorData] = React.useState(null);
  const [page, setPage] = React.useState("order");
  const [pageNum, setPageNum] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [loadingAddress, setLoadingAddress] = React.useState(false);
  const [loadingAdd, setLoadingAdd] = React.useState(false);
  const [loadingItem, setLoadingItem] = React.useState(false);
  const [loadingCalculate, setLoadingCalculate] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);
  const [customer, setcustomer] = React.useState(null);
  const [countryData, setCountryData] = React.useState([]);
  const [stateData, setStateData] = React.useState([]);
  const [zipStatus, setZipStatus] = React.useState(false);

  const [inventory, setInventory] = React.useState(null);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);
  // console.log(selectedCustomer);
  const [customerAddress, setCustomerAddress] = React.useState([]);
  const [selectedShippingCustomerAddress, setSelectedShippingCustomerAddress] =
    React.useState(null);
  const [selectedBillingCustomerAddress, setSelectedBillingCustomerAddress] =
    React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [productList, setProductList] = React.useState([]);
  const [shippingFee, setShippingFee] = React.useState("0.00");
  const [deposit, setDeposit] = React.useState("0.00");
  const [remark, setRemark] = React.useState({
    sales_remark: "",
    customer_remark: "",
    memo: "",
    bypasscl: false,
  });
  const [discountData, setDiscountData] = React.useState({
    discountpercent: (0).toFixed(2),
    discountvalue: (0).toFixed(2),
  });
  const [orderFee, setOrderFee] = React.useState({
    final_amount: (0).toFixed(2),
    handling_fee: (0).toFixed(2),
    shipping_fee: (0).toFixed(2),
    discountamount: (0).toFixed(2),
    total_amount: (0).toFixed(2),
    tax_fee: (0).toFixed(2),
  });
  const [allData, setAllData] = React.useState([]);
  const [totalList, setTotalList] = React.useState(1);
  const [searchKey, setSearchKey] = React.useState("");
  const [colorSort, setColorSort] = React.useState("false");
  const [classList, setClassList] = React.useState(null);
  const [selectedClass, setSelectedClass] = React.useState("");
  const [merchandiser, setMerchandiser] = React.useState(null);
  const [selectedMerchandiser, setSelectedMerchandiser] = React.useState(0);
  const [rep, setRep] = React.useState(null);
  const [selectedRep, setSelectedRep] = React.useState(0);
  const [billtype, setBilltype] = React.useState(null);
  const [shippingMethod, setShippingMethod] = React.useState([]);
  const [shippingCarrier, setShippingCarrier] = React.useState([]);
  const [selectedShippingMethod, setSelectedShippingMethod] = React.useState({
    shipping_method_id: 0,
    shipping_carrier_id: 0,
  });
  const [viewType, setViewType] = React.useState("grid");
  const [itemGridData, setItemGridData] = React.useState([]);
  const [customerPO, setCustomerPO] = React.useState("");
  const [attachment, setAttachment] = React.useState("");
  // const [polybag, setPolybag] = React.useState("");

  // const handleChangePolybag = (e) => {
  //   setPolybag(e.target.value);
  // };

  const [polybag, setPolybag] = React.useState(0); // Initialize as 0 (false)

  const handleChangePolybag = (event) => {
    setPolybag(event.target.checked ? 1 : 0); // Convert true to 1, false to 0
    console.log(event.target.checked ? 1 : 0);
  };
  const handleChangeRemark = (e) => {
    setRemark({
      ...remark,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeDiscount = (e) => {
    console.log(e.target);
    if (e.target.name == "change") {
      var temp_value =
        (parseFloat(e.target.value) / 100) *
        parseFloat(e.target.total.replace(/,/g, ""));
      setDiscountData({
        ...discountData,
        discountvalue: temp_value.toFixed(2),
        [e.target.name]: e.target.value,
      });
      // setTimeout(() => {

      //     setLoadingCalculate(false)
      // }, 500);
      return;
    }
    if (e.target.name == "discountvalue") {
      var temp_value =
        (parseFloat(e.target.value) /
          parseFloat(orderFee.total_amount.replace(/,/g, ""))) *
        100;
      setDiscountData({
        ...discountData,
        discountpercent: temp_value.toFixed(2),
        [e.target.name]: e.target.value,
      });
      // setLoadingCalculate(false)
      return;
    }
    if (e.target.name == "discountpercent") {
      var temp_value =
        (parseFloat(e.target.value) / 100) *
        parseFloat(orderFee.total_amount.replace(/,/g, ""));
      setDiscountData({
        ...discountData,
        discountvalue: temp_value.toFixed(2),
        [e.target.name]: e.target.value,
      });
      // setLoadingCalculate(false)
      return;
    }
  };

  const searchData = (data, searchKey) => {
    console.log(searchKey);
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          (data[i].itemname &&
            data[i].itemname.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1) ||
          (data[i].displayname &&
            data[i].displayname.toUpperCase().indexOf(searchKey.toUpperCase()) >
              -1)
        ) {
          _data.push(data[i]);
        } else if (data[i].children && data[i].children.length) {
          for (var j = 0; j < data[i].children.length; j++) {
            if (
              (data[i].children[j].hscode &&
                data[i].children[j].hscode
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1) ||
              (data[i].children[j].itemname &&
                data[i].children[j].itemname
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1) ||
              (data[i].children[j].displayname &&
                data[i].children[j].displayname
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1)
              // || data[i].children[j].colorname && data[i].children[j].colorname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
            ) {
              _data.push(data[i]);
            }
          }
        }
      }
    } else {
      _data = [...data];
      console.log("Clear", data);
    }
    return _data;
  };

  const handleSearch = (event) => {
    // if (event.target.name == "search") {
    setSearchKey(event.target.value);

    var _data = searchData(allData, event.target.value);
    setInventory(_data);
    setTotalList(_data.length);
  };

  const getData = () => {
    setLoading(true);
    get_customer_contact({
      page: 1,
    }).then((json) => {
      setLoading(false);
      setcustomer(json.data);
    });
    get_class({}).then((resClass) => {
      setClassList(resClass.data);
      setSelectedClass(resClass.data[0].class);
    });
    get_merchandiser({}).then((resMer) => {
      setMerchandiser(resMer.data);
      // setSelectedMerchandiser(resMer.data[0].internalid)
    });
    get_sales_rep({}).then((resRep) => {
      setRep(resRep.data);
      // setSelectedRep(resRep.data[0].internalid);
    });
  };

  const [customerId, setCustomerId] = useState(0);

  // const filterInventoryByColor = (color) => {
  //   const filteredData = allData.filter(item => color === false || item.colorname === color);
  //   setInventory(filteredData);
  //   setTotalList(filteredData.length);

  //   console.log(color)
  // };

  // React.useEffect(() => {

  //   filterInventoryByColor(colorSort)
  // }, [colorSort, allData]);

  const getInventory = (e) => {
    setLoadingItem(true);
    var temp_product = [];
    setCustomerId(e);
    get_inventory_by_customer({
      customer_id: e,
      color: colorSort,
      // sort: sort
    }).then((json) => {
      setLoadingItem(false);
      temp_product = [...json.data];
      for (var i = 1; i < temp_product.length; i++) {
        temp_product[i]["openTable"] = false;
      }
      setAllData(temp_product);
      var _data = searchData(temp_product, searchKey);
      setInventory(_data);
      setTotalList(_data.length);
    });
  };

  React.useEffect(() => {
    if (selectedCustomer != null) {
      getInventory(selectedCustomer.customer_id);
    }
  }, [colorSort]);

  // const handleChangeTable = (e) => {
  //   var temp_data = [...inventory];
  //   temp_data[e]["openTable"] = !temp_data[e]["openTable"];
  //   setInventory(temp_data);
  // };

  const handleChangeTable = async (item) => {
    console.log(open);
    if (!open[item.item_id]) {
      var res = await get_inventory_by_customer_children({
        internalid: item.internalid,
        customer_id: customerId,
      });
      if (res.status) {
        var _product = [...allData];
        item.children = res.data.children;
        item.children_grid = res.data.children_grid;

        setAllData(_product);
        var _data = searchData(_product, searchKey);
        setInventory(_data);
      }
    }

    setOpen((prev) => {
      const newState = { ...prev };
      // console.log(newState);
      Object.keys(newState).forEach((key) => {
        if (key !== item.item_id) {
          newState[key] = false;
        }
      });
      newState[item.item_id] = !prev[item.item_id];
      return newState;
    });
  };

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const [selectedCustomerAdditionalInfo, setSeelctedCustomerAdditionalInfo] =
    React.useState({
      balance: 0,
      depositBalance: 0,
    });
  const handleGetCustomerData = (e) => {
    // console.log('e,e', e)
    const selectedCustomerID = copyCustomerID || e;
    if (selectedCustomerID !== "") {
      setLoadingAddress(true);
      get_customer_detail({
        customer_id: selectedCustomerID,
        // sort: sort
      }).then((json) => {
        setLoadingAddress(false);
        setCustomerAddress(json.data.address);
        setSelectedBillingCustomerAddress({
          ...selectedBillingCustomerAddress,
          customer_address_id: json.data.default_billing_address_id,
          contact_name: json.data.contact_name,
          contact_number: json.data.contact_number,
          addr1: json.data.billing_addr1,
          addr2: json.data.billing_addr2,
          city: json.data.billing_city,
          zip: json.data.billing_zip,
          state: json.data.billing_state,
          country: json.data.billing_country,
        });
        setSeelctedCustomerAdditionalInfo({
          balance: json.data.balance,
          depositBalance: json.data.depositBalance,
        });
        setSelectedShippingCustomerAddress(null);
        setSelectedRep(json.data.salesrep);
        // console.log(json.data.subsidiary, json.data.subsidiary == 2)
        if (json.data.subsidiary == 2) {
          setBilltype("SST");
        } else {
          setBilltype("GST");
        }
      });
    } else {
      setCustomerAddress([]);
      setSelectedBillingCustomerAddress(null);
      setSelectedShippingCustomerAddress(null);
    }
  };
  // console.log("productList", productList);
  const handleGetShippingMethod = (e) => {
    // console.log('e,e', e)
    const selectedCustomerContactID = copyCustomerContactID || e;
    if (selectedCustomerContactID !== "") {
      get_shipping_method_admin({
        customer_contact_id: selectedCustomerContactID,
        // sort: sort
      }).then((json) => {
        setShippingMethod(json.data);
        setShippingCarrier([]);
        setSelectedShippingMethod({
          shipping_carrier_id: 0,
          shipping_method_id: 0,
        });
      });
    } else {
      setShippingMethod([]);
      setShippingCarrier([]);
      setSelectedShippingMethod({
        shipping_carrier_id: 0,
        shipping_method_id: 0,
      });
    }
  };

  const getColor = () => {
    get_color_name({}).then((json) => {
      setColorData(json.data);
      // setTotalList(json.total);
    });
  };

  React.useEffect(() => {
    getData();
    getColor();
    // getInventory();
  }, []);

  const [uploadPDF, setUploadPDF] = React.useState("");
  //DropZone

  const dropzone = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    marginBottom: ".6rem",
  };

  const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
  };

  const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    // width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
  };

  const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  };

  const img = {
    display: "block",
    width: "auto",
    height: "100%",
  };

  const [files, setFiles] = React.useState([]);
  const [files2, setFiles2] = React.useState([]);
  const [files3, setFiles3] = React.useState([]);
  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    // accept: "image/jpeg, image/png",
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        // const file = Array.from(acceptedFiles);

        var index = 0;

        var formData = new FormData();

        // for (let i = 0; i < file.length; i++) {
        //   formData.append("image[]", file[i]);
        //   index = i;
        // }

        formData.append("image", file);

        if (productList.length === 0) {
          toast("Please add item");
          return;
        } else {
          var res = await get_upload_file(formData);
          if (res.data.status) {
            // setUploadAttachment({
            //   ...uploadAttachment,
            //   attachment: res.data.data,
            // });
            setUploadPDF({
              file: res.data.data,
            });
            calculateCart();
          } else {
            // alert(res.data.message);
          }
        }
      } else {
        toast("Please Upload One Consignment Note Only");
      }
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const attachmentDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setAttachment(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const customerpoDropzone = useDropzone({
    maxFiles: 1,
    onDrop: async (acceptedFiles) => {
      console.log(acceptedFiles);
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        var index = 0;
        var formData = new FormData();
        formData.append("image", file);

        var res = await get_upload_file(formData);
        if (res.data.status) {
          setCustomerPO(res.data.data);
        } else {
        }
      } else {
        toast("Please Upload One File Only");
      }
      setFiles3(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete(index)}
      />
    </div>
  ));

  const thumbs2 = files2.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete2(index)}
      />
    </div>
  ));

  const thumbs3 = files3.map((file, index) => (
    <div
      style={{
        background: "#eaeaea",
        borderRadius: "4px",
        padding: "1rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div key={file.name} style={{ display: "flex", alignItems: "center" }}>
        {file.type == "application/pdf" && (
          <InsertDriveFile sx={{ marginRight: "12px", color: "#F90000" }} />
        )}
        {file.type == "image/png" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        {file.type == "image/jpeg" && (
          <InsertPhoto sx={{ marginRight: "12px", color: "#00b5a2" }} />
        )}

        <p style={{ margin: 0 }}>{file.name}</p>
      </div>
      <Close
        sx={{ color: "#F90000", zIndex: 1 }}
        onClick={() => handleDelete3(index)}
      />
    </div>
  ));

  const handleDelete = async (fileIndex) => {
    const updatedFiles = [...files];
    updatedFiles.splice(fileIndex, 1);
    setFiles(updatedFiles);
    setUploadPDF({
      file: "",
    });
    calculateCart();
  };

  const handleDelete2 = async (fileIndex) => {
    const updatedFiles = [...files2];
    updatedFiles.splice(fileIndex, 1);
    setFiles2(updatedFiles);
    setAttachment("");
    calculateCart();
  };

  const handleDelete3 = async (fileIndex) => {
    const updatedFiles = [...files3];
    updatedFiles.splice(fileIndex, 1);
    setFiles3(updatedFiles);
    setCustomerPO("");
    calculateCart();
  };

  // const fileRejectionItems = fileRejections.map(({ file, errors }) => {
  //   return (
  //     <>
  //       {errors.map((e) => (
  //         <Paragraph key={e.code}>{e.message}</Paragraph>
  //       ))}
  //     </>
  //   );
  // });

  const handleSubmitOrder = () => {
    setLoadingAdd(true);
    // console.log(selectedCustomer, selectedShippingCustomerAddress, productList, data)
    if (selectedCustomer === null) {
      setLoadingAdd(false);
      toast("Please Choose Customer");

      return;
    }
    // if (selectedBillingCustomerAddress === null) {
    //     toast('Please choose a billing address')
    //     return
    // }
    if (selectedShippingCustomerAddress === null) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Address");
      return;
    }
    if (selectedShippingMethod.shipping_method_id === 0) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Method");
      return;
    }
    if (
      shippingCarrier.length > 0 &&
      selectedShippingMethod.shipping_carrier_id === 0
    ) {
      setLoadingAdd(false);
      toast("Please Choose Shipping Carrier");
      return;
    }
    if (productList.length === 0) {
      setLoadingAdd(false);
      toast("Please add item");
      return;
    }

    var _productList = [...productList];
    for (var i = 0; i < _productList.length; i++) {
      _productList[i]["description"] = encodeURIComponent(
        _productList[i]["description"]
      );
    }

    var data = {
      ...selectedShippingMethod,
      ...remark,
      ...discountData,
      ...uploadPDF,
      bypasscl: remark.bypasscl ? 1 : 0,
      item: JSON.stringify(_productList),
      shipping_fee: orderFee.shipping_fee,
      class: selectedClass,
      customer_contact_id: selectedCustomer.customer_contact_id,
      customer_address_id: selectedShippingCustomerAddress.customer_address_id,
      billing_address_id: selectedBillingCustomerAddress.customer_address_id,
      deposit_amount: deposit,
      merchandiser: selectedMerchandiser,
      salesrep: selectedRep,
      customorderpo: customerPO,
      attachment: attachment,
      polybag: polybag === 1 ? "true" : "false",
    };

    // console.log(data);
    // return;

    create_orders_admin(data).then((json) => {
      if (typeof json.status !== "undefined") {
        alert(json.message);
        setLoadingAdd(false);
        // return;
      } else {
        // setLoadingAdd(false);
        // return;
        navigate("/saledetail/" + json);
      }
    });
  };

  var open_product_list_counter = useRef(0);
  const handleCheckAction = () => {
    if (selectedCustomer === null) {
      toast("Please Choose Customer");
      return;
    }
    // if (selectedBillingCustomerAddress === null) {
    //     toast('Please choose a billing address')
    //     return
    // }
    if (selectedShippingCustomerAddress === null) {
      toast("Please Choose Shipping Address");
      return;
    }
    if (selectedShippingMethod.shipping_method_id === 0) {
      toast("Please Choose Shipping Method");
      return;
    }
    open_product_list_counter.current++;
    setSelectedItem(null);
    setPage("product");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleOpen = (e) => {
    console.log(e);
    setOpen(true);
    // console.log(e)
    setSelectedItem({
      internalid: e.internalid,
      quantity: 1,
      description: "",
      hscode: e.hscode,
      itemname: e.itemname,
      color: e.colorname != "" ? e.colorname + " " + e.color : "",
      size: e.size != "" ? e.size : "",
      price: e.hasOwnProperty("price") ? e.price : "",
      type: e.type,
      quantityavailable: e.quantityavailable,
    });
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const handleChangeProduct = (e) => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeProduct2 = (e) => {
    const newValue = e.target.value;
    const newQuantity = newValue < 1 ? 1 : newValue;

    setSelectedItem({
      ...selectedItem,
      [e.target.name]: newQuantity,
    });
  };

  const addProduct = () => {
    if (
      selectedItem.type == "Matrix Item" &&
      parseFloat(selectedItem.quantity) >
        parseFloat(selectedItem.quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }
    // selectedItem.type != 'Matrix Item'
    // if (selectedItem.type == 'Matrix Item' && selectedItem.price == 0) {
    //     toast('0 Price value cannot add to cart')
    //     return
    // }
    if (
      selectedItem.type != "Matrix Item" &&
      selectedItem.type != "Dropship Item" &&
      selectedItem.price == 0
    ) {
      toast("Please insert price");
      return;
    }
    // console.log(selectedItem)
    var pro_temp = [...productList];
    if (pro_temp.length === 0) {
      selectedItem["index"] = 0;
      pro_temp.push(selectedItem);
    } else {
      var existed = 0;
      var index = 0;
      for (var i = 0; i < pro_temp.length; i++) {
        if (
          (selectedItem.type == "Matrix Item" ||
            selectedItem.type == "Dropship Item") &&
          pro_temp[i].internalid === selectedItem.internalid
        ) {
          existed = 1;
          index = i;
          break;
        } else if (
          selectedItem.type != "Matrix Item" &&
          selectedItem != "Dropship Item"
        ) {
          existed = 0;
          index = i;
          break;
        }
      }

      if (existed == 1) {
        if (
          (selectedItem.type == "Matrix Item" ||
            selectedItem.type == "Dropship Item") &&
          parseFloat(pro_temp[index].quantity) +
            parseFloat(selectedItem.quantity) >
            parseFloat(selectedItem.quantityavailable)
        ) {
          toast("Not Enough Quantity");
          return;
        }
        // console.log(parseFloat(pro_temp[index].quantity), parseFloat(selectedItem.quantity))
        var new_quantity =
          parseFloat(pro_temp[index].quantity) +
          parseFloat(selectedItem.quantity);

        pro_temp[index]["quantity"] = new_quantity;
        // cartTemp[index]['price'] = getPriceByQuantity(
        //     cartTemp[index],
        //     new_quantity,
        // );
      } else {
        selectedItem["index"] = pro_temp.length;
        pro_temp.push(selectedItem);
      }
    }
    setProductList(pro_temp);
    // setDiscountData({
    //     ...discountData,
    //     discountpercent: (0).toFixed(2),
    //     discountvalue: (0).toFixed(2)
    // })
    toast("Product Added");
    handleClose();
  };

  var qty_timer = useRef(null);

  const handleChangeQty = (index, qty) => {
    if (!selectedCustomer) {
      toast("Please Choose Customer");
      return;
    }

    if (!selectedShippingCustomerAddress) {
      toast("Please Choose Shipping Address");
      return;
    }

    if (!selectedShippingMethod || !selectedShippingMethod.shipping_method_id) {
      toast("Please Choose Shipping Method");
      return;
    }

    if (
      shippingCarrier.length > 0 &&
      selectedShippingMethod.shipping_carrier_id === 0
    ) {
      toast("Please Choose Shipping Carrier");
      return;
    }

    // setLoadingAdd(false);
    clearTimeout(qty_timer.current);
    var pro_temp = [...productList];

    var new_quantity = parseFloat(pro_temp[index].quantity) + parseFloat(qty);
    console.log(new_quantity);
    if (
      pro_temp[index].type == "Matrix Item" &&
      parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    pro_temp[index]["quantity"] = new_quantity;

    for (var i = 0; i < pro_temp.length; i++) {
      if (pro_temp[i].quantity < 1) {
        pro_temp.splice(i, 1);
      }
    }

    setProductList(pro_temp);

    qty_timer.current = setTimeout(() => {
      calculateCart();
    }, 3000);
  };

  const handleChangeQtyText = (index, e) => {
    var pro_temp = [...productList];
    var new_quantity = parseFloat(e.target.value);

    // Check if the new quantity is a valid number
    if (isNaN(new_quantity)) {
      // If it's not a number, set the new quantity to the previous value
      new_quantity = pro_temp[index]["quantity"];
    } else if (
      pro_temp[index].type == "Matrix Item" &&
      parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable)
    ) {
      toast("Not Enough Quantity");
      return;
    }

    pro_temp[index]["quantity"] = new_quantity;
    setProductList(pro_temp);
    calculateCart();
  };

  const handleChangeDiscountText = (index, e) => {
    var pro_temp = [...productList];
    var new_discount = parseFloat(e.target.value);
    // console.log(parseFloat(new_quantity) > parseFloat(pro_temp[index].quantityavailable), parseFloat(new_quantity), parseFloat(pro_temp[index].quantityavailable))
    // pro_temp[index].type == "Matrix Item"
    if (isNaN(new_discount)) {
      new_discount = 0;
    }
    pro_temp[index]["given_discount"] = new_discount;
    setProductList(pro_temp);
    calculateCart();
  };

  const handleRemoveItem = (i) => {
    var temp_data = [...productList];

    temp_data.splice(i, 1);

    setProductList(temp_data);

    var _productList = [...temp_data];
    for (var i = 0; i < _productList.length; i++) {
      _productList[i]["description"] = encodeURIComponent(
        _productList[i]["description"]
      );
    }

    if (
      selectedCustomer !== null &&
      selectedShippingCustomerAddress !== null &&
      selectedShippingMethod.shipping_method_id !== 0
    ) {
      var data = {
        ...discountData,
        ...uploadPDF,
        item: JSON.stringify(_productList),
        // shipping_fee: shippingFee,
        shippingFee: orderFee.shipping_fee,
        class: selectedClass,
        customer_contact_id: selectedCustomer.customer_contact_id,
        customer_address_id:
          selectedShippingCustomerAddress.customer_address_id,
        billing_address_id: selectedBillingCustomerAddress.customer_address_id,
        shipping_method_id: selectedShippingMethod.shipping_method_id,
      };

      validate_cart_admin(data).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          var _product = [...json.data];
          for (var i = 0; i < _product.length; i++) {
            _product[i]["description"] = decodeURIComponent(
              _product[i]["description"]
            );
          }
          setProductList(_product);
          setOrderFee({
            ...orderFee,
            // consignment_note: uploadPDF,
            total_amount: json.total_amount,
            discountamount: json.discountamount,
            is_input: orderFee.shipping_fee_custom ? 1 : 0,
            // shipping_fee_custom: false,
            shipping_fee: json.shipping_fee,
            handling_fee: json.handling_fee,
            final_amount: json.final_amount,
            tax_fee: billtype == "SST" ? json.sst : json.gst,
          });
        } else {
        }
      });
    }
  };

  var is_changing_shipping_fee = useRef(null);
  var is_calculating = false;

  const calculateCart = () => {
    console.log("IS_CALCULATING", is_calculating, orderFee);
    if (is_calculating) {
      return;
    }
    is_calculating = true;
    if (
      selectedCustomer !== null &&
      selectedShippingCustomerAddress !== null &&
      // selectedBillingCustomerAddress !== null &&
      selectedShippingMethod.shipping_method_id !== 0
    ) {
      var _productList = [...productList];
      for (var i = 0; i < _productList.length; i++) {
        _productList[i]["description"] = encodeURIComponent(
          _productList[i]["description"]
        );
      }
      var data = {
        ...discountData,
        ...uploadPDF,
        item: JSON.stringify(_productList),
        // shipping_fee: shippingFee,
        is_input: orderFee.shipping_fee_custom ? 1 : 0,
        shippingFee: orderFee.shipping_fee,
        class: selectedClass,
        customer_contact_id: selectedCustomer.customer_contact_id,
        customer_address_id:
          selectedShippingCustomerAddress.customer_address_id,
        billing_address_id: selectedBillingCustomerAddress.customer_address_id,
        shipping_method_id: selectedShippingMethod.shipping_method_id,
      };

      validate_cart_admin(data)
        .then((json) => {
          // setLoadingAdd(true);
          if (json.status) {
            var _product = [...json.data];
            for (var i = 0; i < _product.length; i++) {
              for (var i = 0; i < _product.length; i++) {
                _product[i]["description"] = decodeURIComponent(
                  _product[i]["description"]
                );
              }
            }
            setProductList(_product);
            // setProductList(json.data);
            setOrderFee({
              ...orderFee,
              // consignment_note: uploadPDF,
              total_amount: json.total_amount,

              discountamount: json.discountamount,
              // shipping_fee_custom: false,
              shipping_fee: json.shipping_fee,
              handling_fee: json.handling_fee,
              final_amount: json.final_amount,
              tax_fee: billtype == "SST" ? json.sst : json.gst,
            });
            is_calculating = false;
          } else {
            is_calculating = false;
          }
        })
        .catch((e) => {
          is_calculating = false;
        });
    } else {
      is_calculating = false;
    }
  };

  React.useEffect(() => {
    // setLoadingCalculate(true)
    handleChangeDiscount({
      target: {
        name: "change",
        value: discountData.discountpercent,
        total: orderFee.total_amount,
      },
    });
  }, [orderFee.total_amount]);
  React.useEffect(() => {
    // calculateCart();
    // getInventory();
  }, [
    // productList,
    shippingFee,
    selectedShippingMethod,
    // selectedBillingCustomerAddress,
    selectedShippingCustomerAddress,
    discountData,
    uploadPDF,
  ]);

  useEffect(() => {
    if (orderFee.shipping_fee_custom) {
      is_changing_shipping_fee.current = setTimeout(() => {
        console.log("DONE");
        console.log(orderFee.shipping_fee);
        calculateCart();
      }, 1500);
    }
  }, [orderFee.shipping_fee]);
  const calculatePrice = () => {
    var cartTemp = [...productList];

    var total_cart_price = 0;

    for (var i = 0; i < cartTemp.length; i++) {
      total_cart_price +=
        parseFloat(cartTemp[i].price) * parseFloat(cartTemp[i].quantity);
    }
    return total_cart_price;
  };

  const handleChangeShippingMethod = (e) => {
    setSelectedShippingMethod({
      ...selectedShippingMethod,
      shipping_method_id: e.shipping_method_id,
      shipping_carrier_id: 0,
    });
    setShippingCarrier(e.carrier);
  };

  const handleChangeShippingCarrier = (e) => {
    setSelectedShippingMethod({
      ...selectedShippingMethod,
      shipping_carrier_id: e.shipping_carrier_id,
    });
  };
  const [openAdd, setOpenAdd] = React.useState(false);
  const [addressAddData, setAddressAddData] = React.useState({
    contact_name: "",
    contact_number: "",
    addr1: "",
    addr2: "",
    city: "",
    zip: "",
    state: 0,
    country: 0,
  });

  const handleOpenAdd = (e) => {
    if (selectedCustomer === null) {
      toast("Please Choose Customer");
      return;
    }
    get_country({}).then((json) => {
      setOpenAdd(true);
      setCountryData(json.data);
      // setTotalList(json.total);
    });
    get_state({}).then((json) => {
      setStateData(json.data);
      // setTotalList(json.total);
    });
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleChangeAddAddress = (e) => {
    setAddressAddData({
      ...addressAddData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name == "zip") {
      validate_state({
        zip: e.target.value,
        state: addressAddData.state,
        // sort: sort
      }).then((jsonth) => {
        if (jsonth.status) {
          setZipStatus(false);
        } else {
          setZipStatus(true);
        }
      });
      return;
    }
    if (e.target.name == "state") {
      validate_state({
        state: e.target.value,
        zip: addressAddData.zip,
        // sort: sort
      }).then((jsonth) => {
        if (jsonth.status) {
          setZipStatus(false);
        } else {
          setZipStatus(true);
        }
      });
      return;
    }
  };
  // console.log(selectedCustomer)
  const handleAddAddress = () => {
    if (addressAddData.contact_name == 0) {
      toast("Please enter contact number");
      return;
    }
    if (addressAddData.contact_number == 0) {
      toast("Please enter contact number");
      return;
    }
    if (addressAddData.addr1.length == 0) {
      toast("Please enter address 1");
      return;
    }
    if (addressAddData.addr2.length == 0) {
      toast("Please enter address 2");
      return;
    }
    if (addressAddData.city.length == 0) {
      toast("Please enter city");
      return;
    }
    if (addressAddData.zip.length == 0) {
      toast("Please enter zipcode");
      return;
    }
    if (addressAddData.state.length == 0) {
      toast("Please enter state");
      return;
    }
    if (addressAddData.country == 0) {
      toast("Please select country");
      return;
    }
    setLoading(true);
    add_address_admin({
      ...addressAddData,
      customer_id: selectedCustomer.customer_id,
    }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Address Add Succcessful");
        handleCloseAdd();
        getData();
        setAddressAddData({
          contact_name: "",
          contact_number: "",
          addr1: "",
          addr2: "",
          city: "",
          zip: "",
          state: 0,
          country: 0,
        });
        handleGetCustomerData(selectedCustomer.customer_id);
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };
  const [openAddDesc, setOpenAddDesc] = React.useState(false);
  const [openEditDesc, setOpenEditDesc] = React.useState(false);
  const [selectedGrid, setSelectedGrid] = React.useState(null);
  const [selectedIndexProduct, setSelectedIndexProduct] = React.useState(null);

  const handleOpenAddDesc = (e) => {
    setOpenAddDesc(true);
    // console.log(e)
    setSelectedGrid({
      ...e,
      description: "",
    });
  };

  const handleChangeDesc = (e) => {
    // console.log(e.target.value);
    setSelectedGrid({
      ...selectedGrid,
      [e.target.name]: e.target.value,
    });
  };
  const handleCloseAddDesc = (e) => {
    setSelectedGrid(null);
    setOpenAddDesc(false);
  };
  const handleOpenAddIndexProduct = (e) => {
    console.log(e);
    setOpenEditDesc(true);
    setSelectedIndexProduct({
      ...e,
    });
  };

  const handleCloseIndexProduct = () => {
    if (selectedIndexProduct) {
      // Make sure selectedIndexProduct is not null
      const pro_temp = [...productList];
      const selectedIndex = pro_temp.findIndex(
        (item) => item.internalid === selectedIndexProduct.internalid
      );

      if (selectedIndex !== -1) {
        // Check if the selectedIndex is valid
        pro_temp[selectedIndex] = {
          ...pro_temp[selectedIndex],
          description: selectedIndexProduct.description,
        };

        setProductList(pro_temp);
        setSelectedIndexProduct(null);
        setOpenEditDesc(false);
      }
    }
  };

  const handleChangeIndexProduct = (e) => {
    setSelectedIndexProduct({
      ...selectedIndexProduct,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddDEsc = () => {
    if (parseFloat(selectedGrid.quantityavailable) < 1) {
      toast("Not Enough Quantity");
      return;
    }
    var temp_list = [...productList];
    var data = {
      ...selectedGrid,
      quantity: 1,
    };

    let existed = false;
    let index = 0;
    for (let i = 0; i < temp_list.length; i++) {
      if (temp_list[i].internalid === data.internalid) {
        existed = true;
        index = i;
        break;
      }
    }

    if (existed) {
      if (
        parseFloat(temp_list[index].quantity) + parseFloat(data.quantity) >
        parseFloat(selectedGrid.quantityavailable)
      ) {
        toast("Not Enough Quantity");
        return;
      }
      temp_list[index].quantity =
        parseFloat(temp_list[index].quantity) + parseFloat(data.quantity);
      // temp_list[index].description = parseFloat(data.quantity);
      if (temp_list[index].description.length == 0) {
        temp_list[index].description = data.description;
      }
    } else {
      data.index = temp_list.length;
      temp_list.push(data);
    }
    console.log("TEMP LIST", temp_list);
    setProductList(temp_list);
    // setDiscountData({
    //     ...discountData,
    //     discountpercent: (0).toFixed(2),
    //     discountvalue: (0).toFixed(2)
    // })
    // toast('Product Added');
    handleCloseAddDesc();
  };

  const handleChangeGrid = (e, index, item) => {
    if (e.target.value == "") {
      toast("Please Insert Quantity");
      return;
    }
    if (e.target.value == 0) {
      toast("Quantity Cannot be 0");
      return;
    }

    let list = [...productList];

    var data = e.target.id;
    var datasplit = data.split("_");
    var internalid = datasplit[0];
    var hscode = datasplit[1];
    var itemname = datasplit[2];
    var price = datasplit[3];
    var type = datasplit[4];
    var color = datasplit[5];
    var quantityavailable = datasplit[6];
    var size = datasplit[7];
    var quantity = e.target.value !== "" ? parseInt(e.target.value) : 0;

    if (quantity > 0) {
      if (item.type != "Dropship Item" && quantity > quantityavailable) {
        toast("Not enough quantity available");
        return;
      }

      var data = {
        hscode: hscode,
        itemname: itemname,
        price: price,
        type: type,
        color: color,
        quantity: e.target.value,
        internalid: internalid,
        description: "",
        quantityavailable: quantityavailable,
        size: size,
        productListCounter: open_product_list_counter.current,
      };

      console.log("data", data);
      var existed = 0;
      // alert(open_product_list_counter.current)

      for (var i = 0; i < list.length; i++) {
        if (
          internalid == list[i].internalid &&
          open_product_list_counter.current == list[i].productListCounter
        ) {
          existed = 1;
          list[i] = data;
        }
      }

      if (existed == 0 && data.quantity >= 1) {
        data["index"] = list.length;
        list.push(data);
      }
    } else {
      for (var i = 0; i < list.length; i++) {
        if (internalid == list[i].internalid) {
          list.splice(i, 1);
        }
      }
    }

    setProductList(list);
  };

  const handleCaptureSingle = async (e, index) => {
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append("image", e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);
    // console.log(res)
    if (res.data.status) {
      if (e.target.name == "attachment") {
        setAttachment(res.data.data);
        return;
      }
      if (e.target.name == "customerpo") {
        setCustomerPO(res.data.data);
        return;
      }
    } else {
      toast(res.data.message);
    }
  };

  // COPIED DATA FROM SALE DETAIL

  const [copiedData, setCopiedData] = useState("");
  const [copyProduct, setCopyProduct] = React.useState("");

  const [copyCustomerID, setCopyCustomerID] = React.useState("");
  const [copyCustomerContactID, setCopyCustomerContactID] = React.useState("");

  // React.useEffect(() => {
  //   navigator.clipboard
  //     .readText()
  //     .then((text) => {
  //       try {
  //         const parsedData = JSON.parse(text);
  //         setCopiedData(parsedData);
  //         setCopyCustomerID(parsedData.customer_id);
  //         setCopyCustomerContactID(parsedData.customer_contact_id);
  //         console.log("COPY DATA", parsedData);

  //         var _productList = [...productList];
  //         for (var i = 0; i < _productList.length; i++) {
  //           _productList[i]["description"] = encodeURIComponent(
  //             _productList[i]["description"]
  //           );
  //         }
  //         var data = {
  //           ...discountData,
  //           ...uploadPDF,
  //           item: JSON.stringify(_productList),
  //           is_input: orderFee.shipping_fee_custom ? 1 : 0,
  //           shippingFee: orderFee.shipping_fee,
  //           class: selectedClass,
  //           customer_contact_id: parsedData.customer_contact_id,
  //           customer_address_id: parsedData.customer_address_id,
  //           billing_address_id: parsedData.customer_address_id,
  //           shipping_method_id: parsedData.shipping_method_id,
  //         };

  //         validate_cart_admin(data)
  //           .then((json) => {
  //             if (json.status) {
  //               var _product = [...json.data];
  //               for (var i = 0; i < _product.length; i++) {
  //                 for (var i = 0; i < _product.length; i++) {
  //                   _product[i]["description"] = decodeURIComponent(
  //                     _product[i]["description"]
  //                   );
  //                 }
  //               }
  //               setProductList(_product);

  //               setOrderFee({
  //                 ...orderFee,
  //                 total_amount: json.total_amount,
  //                 discountamount: json.discountamount,
  //                 shipping_fee: json.shipping_fee,
  //                 handling_fee: json.handling_fee,
  //                 final_amount: json.final_amount,
  //                 tax_fee: billtype == "SST" ? json.sst : json.gst,
  //               });
  //               is_calculating = false;
  //             } else {
  //               is_calculating = false;
  //             }
  //           })
  //           .catch((e) => {
  //             is_calculating = false;
  //           });

  //         get_customer_detail({
  //           customer_id: parsedData.customer_id,
  //         }).then((json) => {
  //           setLoadingAddress(false);
  //           setCustomerAddress(json.data.address);
  //           setSelectedBillingCustomerAddress({
  //             ...selectedBillingCustomerAddress,
  //             customer_address_id: json.data.default_billing_address_id,
  //             addr1: json.data.billing_addr1,
  //             addr2: json.data.billing_addr2,
  //             city: json.data.billing_city,
  //             zip: json.data.billing_zip,
  //             state: json.data.billing_state,
  //             country: json.data.billing_country,
  //           });
  //           setSeelctedCustomerAdditionalInfo({
  //             balance: json.data.balance,
  //             depositBalance: json.data.depositBalance,
  //           });
  //           setSelectedShippingCustomerAddress(null);
  //           setSelectedRep(json.data.salesrep);
  //           if (json.data.subsidiary == 2) {
  //             setBilltype("SST");
  //           } else {
  //             setBilltype("GST");
  //           }
  //         });

  //         get_shipping_method_admin({
  //           customer_contact_id: parsedData.customer_contact_id,
  //           // sort: sort
  //         }).then((json) => {
  //           setShippingMethod(json.data);
  //           setShippingCarrier([]);
  //           setSelectedShippingMethod({
  //             shipping_carrier_id: parsedData.shipping_carrier_id,
  //             shipping_method_id: parsedData.shipping_method_id,
  //           });
  //         });

  //         if (parsedData.item && Array.isArray(parsedData.item)) {
  //           // Filter out items with 'Service Item'
  //           const filteredItems = parsedData.item.filter(
  //             (item) => item.type !== "Service Item"
  //           );
  //           setCopyProduct(filteredItems);
  //           setProductList(filteredItems);
  //         } else {
  //           console.error("Invalid data format in clipboard.");
  //         }
  //       } catch (error) {
  //         console.error("Error parsing clipboard data:", error);
  //       }
  //     })
  //     .catch((error) => console.error("Error reading clipboard:", error));

  //   if (copyCustomerID && customer) {
  //     let preselectedCustomer = customer.find(
  //       (cust) => cust.customer_id === copyCustomerID
  //     );
  //     if (preselectedCustomer) {
  //       setSelectedCustomer(preselectedCustomer);
  //     }
  //   }
  // }, [customer]);

  React.useEffect(() => {
    const handleClipboardData = (text) => {
      const parsedData = JSON.parse(text);
      setCopiedData(parsedData);
      setCopyCustomerID(parsedData.customer_id);
      setCopyCustomerContactID(parsedData.customer_contact_id);
      console.log("COPY DATA", parsedData);

      const encodedProductList = productList.map((item) => ({
        ...item,
        description: encodeURIComponent(item.description),
      }));

      const data = {
        ...discountData,
        ...uploadPDF,
        item: JSON.stringify(encodedProductList),
        is_input: orderFee.shipping_fee_custom ? 1 : 0,
        shippingFee: orderFee.shipping_fee,
        class: selectedClass,
        customer_contact_id: parsedData.customer_contact_id,
        customer_address_id: parsedData.customer_address_id,
        billing_address_id: parsedData.customer_address_id,
        shipping_method_id: parsedData.shipping_method_id,
      };

      setSelectedShippingCustomerAddress({
        ...selectedShippingCustomerAddress,
        customer_address_id: parsedData.customer_address_id,
        addr1: parsedData.addr1,
        addr2: parsedData.addr2,
        city: parsedData.city,
        zip: parsedData.zip,
        state: parsedData.state,
        country: parsedData.country,
        contact_name: parsedData.contact_name,
        contact_number: parsedData.contact_number,
      });

      // setSelectedShippingMethod({
      //   selectedShippingMethod,
      //   shipping_carrier_id: parsedData.shipping_carrier_id,
      //   shipping_method_id: parsedData.shipping_method_id,
      // });

      // ... Your existing useEffect code here ...

      // Filter the data to get the desired shipping method and carrier
      // const filteredShippingMethod = shippingMethod.find(
      //   (item) => item.shipping_method_id === parsedData.shipping_method_id
      // );

      // if (filteredShippingMethod) {
      //   const selectedCarrier = filteredShippingMethod.carrier.find(
      //     (carrier) =>
      //       carrier.shipping_carrier_id === parsedData.shipping_carrier_id
      //   );

      //   if (selectedCarrier) {
      //     setSelectedShippingMethod({
      //       shipping_method_id: filteredShippingMethod.shipping_method_id,
      //       shipping_carrier_id: selectedCarrier.shipping_carrier_id,
      //     });
      //   }
      // }

      validate_cart_admin(data)
        .then((json) => {
          if (json.status) {
            const decodedProductList = json.data.map((item) => ({
              ...item,
              description: decodeURIComponent(item.description),
            }));
            setProductList(decodedProductList);

            setOrderFee({
              ...orderFee,
              total_amount: json.total_amount,
              discountamount: json.discountamount,
              shipping_fee: json.shipping_fee,
              handling_fee: json.handling_fee,
              final_amount: json.final_amount,
              tax_fee: billtype === "SST" ? json.sst : json.gst,
            });

            is_calculating = false;
          } else {
            is_calculating = false;
          }
        })
        .catch((e) => {
          is_calculating = false;
        });

      get_customer_detail({
        customer_id: parsedData.customer_id,
      }).then((json) => {
        setLoadingAddress(false);
        setCustomerAddress(json.data.address);
        setSelectedBillingCustomerAddress({
          ...selectedBillingCustomerAddress,
          customer_address_id: json.data.default_billing_address_id,
          addr1: json.data.billing_addr1,
          addr2: json.data.billing_addr2,
          city: json.data.billing_city,
          zip: json.data.billing_zip,
          state: json.data.billing_state,
          country: json.data.billing_country,
        });

        setSeelctedCustomerAdditionalInfo({
          balance: json.data.balance,
          depositBalance: json.data.depositBalance,
        });
        // setSelectedShippingCustomerAddress(null);
        // setSelectedShippingMethod({
        //   ...selectedShippingMethod,
        //   shipping_carrier_id: parsedData.shipping_carrier_id,
        //   shipping_method_id: parsedData.shipping_method_id,
        // });
        setSelectedRep(json.data.salesrep);

        if (json.data.subsidiary === 2) {
          setBilltype("SST");
        } else {
          setBilltype("GST");
        }
      });

      get_shipping_method_admin({
        customer_contact_id: parsedData.customer_contact_id,
      }).then((json) => {
        setShippingMethod(json.data);
        // setShippingCarrier(parsedData.shipping_carrier_id);
        // setSelectedShippingMethod({
        //   selectedShippingMethod,
        //   shipping_carrier_id: parsedData.shipping_carrier_id,
        //   shipping_method_id: parsedData.shipping_method_id,
        // });

        const filteredShippingMethod = json.data.find(
          (item) => item.shipping_method_id === parsedData.shipping_method_id
        );

        if (filteredShippingMethod) {
          const carrier = filteredShippingMethod.carrier;
          setShippingCarrier(carrier);

          setSelectedShippingMethod({
            shipping_method_id: filteredShippingMethod.shipping_method_id,
            shipping_carrier_id: parsedData.shipping_carrier_id,
          });
        }

        // if (filteredShippingMethod) {
        //   const selectedCarrier = filteredShippingMethod.carrier.find(
        //     (carrier) =>
        //       carrier.shipping_carrier_id === parsedData.shipping_carrier_id
        //   );

        //   if (selectedCarrier) {

        //     const carrier = selectedCarrier.carrier;
        //     setShippingCarrier(carrier);

        //     setSelectedShippingMethod({
        //       shipping_method_id: filteredShippingMethod.shipping_method_id,
        //       shipping_carrier_id: selectedCarrier.shipping_carrier_id,
        //     });
        //   }
        // }
      });

      // if (parsedData.item && Array.isArray(parsedData.item)) {
      //   const filteredItems = parsedData.item.filter(
      //     (item) => item.type == "Service Item"
      //   );
      //   setCopyProduct(filteredItems);
      //   setProductList(filteredItems);
      // } else {
      //   console.error("Invalid data format in clipboard.");
      // }
      setCopyProduct(parsedData.item);
      setProductList(parsedData.item);
    };

    navigator.clipboard
      .readText()
      .then(handleClipboardData)
      .catch((error) => console.error("Error reading clipboard:", error));

    if (copyCustomerID && customer) {
      const preselectedCustomer = customer.find(
        (cust) => cust.customer_id === copyCustomerID
      );
      if (preselectedCustomer) {
        setSelectedCustomer(preselectedCustomer);
      }
    }
  }, [customer]);

  console.log("selectedShippingMethod", selectedShippingMethod);

  console.log("productList", productList);

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <div
          style={{
            position: "relative",
          }}
        >
          {page === "order" ? (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#1A5386"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Create New Order
                      </Paragraph>
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={6}>
                        <Autocomplete
                          id="customer_contact_id"
                          value={selectedCustomer}
                          options={customer}
                          getOptionLabel={(option) =>
                            "#" + option.customer_contact_id + " " + option.entityid + " - " + option.name
                          }
                          onChange={(e, value) => {
                            // console.log('value', value)
                            if (value === null) {
                              setSelectedCustomer(null);
                              handleGetCustomerData("");
                              handleGetShippingMethod("");
                              return;
                            }

                            if (
                              selectedCustomer === null ||
                              productList.length === 0
                            ) {
                              setSelectedCustomer({
                                ...value,
                                customer_id: value.customer_id,
                                dropship: value.dropship,
                              });
                              handleGetCustomerData(value.customer_id);
                              handleGetShippingMethod(
                                value.customer_contact_id
                              );
                              getInventory(value.customer_id);

                              return;
                            }

                            if (
                              window.confirm(
                                "Changing customer will need to clear cart items, are you sure you want to proceed?"
                              )
                            ) {
                              setSelectedCustomer({
                                ...value,
                                customer_id: value.customer_id,
                                dropship: value.dropship,
                              });
                              handleGetCustomerData(value.customer_id);
                              handleGetShippingMethod(
                                value.customer_contact_id
                              );
                              getInventory(value.customer_id);
                              setProductList([]);
                              setOrderFee({
                                final_amount: (0).toFixed(2),
                                handling_fee: (0).toFixed(2),
                                shipping_fee: (0).toFixed(2),
                                given_discount: (0).toFixed(4),
                                total_amount: (0).toFixed(2),
                                tax_fee: (0).toFixed(2),
                              });
                            }
                          }}
                          style={{ width: "100%" }}
                          renderInput={(params) => (
                            <FormInput
                              {...params}
                              label="Customer*"
                              textLabelColor="#000"
                              placeholder="Please Choose A Customer*"
                              name="customer"
                              border="1px solid #c5c5c5"
                            />
                          )}
                        />
                        <FormInput
                          label="Contact"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.phone
                          }
                          textcolor="#707070"
                          placeholder="Contact"
                          name="addr1"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                        <FormInput
                          label="Email"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.email
                          }
                          textcolor="#707070"
                          placeholder="Email"
                          name="email"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                        <FormInput
                          label="Dropship"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.dropship == 0
                              ? "No"
                              : "Yes"
                          }
                          textcolor="#707070"
                          placeholder="Dropship"
                          name="dropship"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormInput
                          label="Payment Type"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.paymenttype
                          }
                          textcolor="#707070"
                          placeholder="Payment Type"
                          name="paymenttype"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                        <FormInput
                          label="Currency"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.currency
                          }
                          textcolor="#707070"
                          placeholder="Currency"
                          name="currency"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                        <FormInput
                          label="Terms"
                          value={
                            selectedCustomer === null
                              ? ""
                              : selectedCustomer.terms
                          }
                          textcolor="#707070"
                          placeholder="Terms"
                          name="terms"
                          bg="#c5c5c5"
                          border="1px solid #c5c5c5"
                          disabled
                          // onChange={handleChangeAddress}
                        />
                        {selectedCustomer !== null && (
                          <React.Fragment>
                            {selectedCustomer.paymenttype == "Credit" && (
                              <FormInput
                                label="Balance"
                                value={selectedCustomerAdditionalInfo.balance}
                                textcolor="#707070"
                                placeholder="Currency"
                                name="currency"
                                bg="#c5c5c5"
                                border="1px solid #c5c5c5"
                                disabled
                              />
                            )}

                            {selectedCustomer.paymenttype == "Prepaid" && (
                              <FormInput
                                label="Deposit Balance"
                                value={selectedCustomerAdditionalInfo.balance}
                                textcolor="#707070"
                                placeholder="Currency"
                                name="currency"
                                bg="#c5c5c5"
                                border="1px solid #c5c5c5"
                                disabled
                              />
                            )}
                          </React.Fragment>
                        )}
                      </Grid>
                    </Grid>
                    <br />

                    {/* credit show balance prepaid show deposit balance */}
                    <div
                      className={classes.theFlexBtn}
                      style={{ marginBottom: "0" }}
                    >
                      <a
                        className={classes.theCustomActionBtn_}
                        // className={classes.theCustomActionBtn}
                        onClick={() => handleOpenAdd()}
                      >
                        <AddCircle sx={{ color: "#1A5386" }} />
                        <Paragraph margin="0 0 0 .4rem">
                          Add New Address
                        </Paragraph>
                      </a>
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />
                    {loadingAddress ? (
                      <div style={{ margin: "auto" }}>
                        <Loader
                          type="bubble-loop"
                          bgColor="#1A5386"
                          size={50}
                        />
                      </div>
                    ) : (
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            id="customer_address_id"
                            value={selectedBillingCustomerAddress}
                            // disabled={
                            //     customerAddress.length == 0 ? true : false
                            // }
                            disabled={true}
                            // name="address_book_id"
                            options={customerAddress}
                            getOptionLabel={(option) =>
                              // option.contact_name +
                              // ", " +
                              // option.contact_number +
                              // ", " +
                              option.addr1 +
                              ", " +
                              option.addr2 +
                              " " +
                              option.city +
                              " " +
                              option.zip +
                              ", " +
                              option.state +
                              ", " +
                              option.country
                            }
                            onChange={(e, value) => {
                              // console.log('value', value)
                              if (value != null) {
                                setSelectedBillingCustomerAddress({
                                  ...selectedBillingCustomerAddress,
                                  customer_address_id:
                                    value.customer_address_id,
                                  contact_name: value.contact_name,
                                  contact_number: value.contact_number,
                                  addr1: value.addr1,
                                  addr2: value.addr2,
                                  city: value.city,
                                  zip: value.zip,
                                  state: value.state,
                                  country: value.country,
                                });
                              } else {
                                setSelectedBillingCustomerAddress({
                                  ...selectedBillingCustomerAddress,
                                  customer_address_id: "",
                                  contact_name: "",
                                  contact_number: "",
                                  addr1: "",
                                  addr2: "",
                                  city: "",
                                  zip: "",
                                  state: "",
                                  country: "",
                                });
                              }
                            }}
                            style={{ width: "100%" }}
                            renderInput={(params) => (
                              <FormInput
                                {...params}
                                label="Billing Address*"
                                // value={addressData.addr1}
                                textLabelColor="#000"
                                placeholder={
                                  customerAddress.length == 0
                                    ? "Please Choose Customer"
                                    : "Please Choose Billing Address"
                                }
                                name="customer_address_id"
                                border="1px solid #c5c5c5"
                                padding="0.6rem 4rem 0.6rem 1rem"
                                // bg={
                                //     customerAddress.length == 0
                                //         ? '#c5c5c5'
                                //         : '#fff'
                                // }
                                bg={"#c5c5c5"}
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password",
                                }}
                                // placeholder='Select Address'
                              />
                            )}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.contact_name
                            }
                            // label="Contact Name*"
                            textcolor="#707070"
                            placeholder="Contact Name"
                            name="contact_name"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.contact_number
                            }
                            // label="Contact Name*"
                            textcolor="#707070"
                            placeholder="Contact Number"
                            name="contact_number"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.addr1
                            }
                            textcolor="#707070"
                            placeholder="Address 1"
                            name="addr1"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.addr2
                            }
                            textcolor="#707070"
                            placeholder="Address 2"
                            name="addr2"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.city
                            }
                            textcolor="#707070"
                            placeholder="City"
                            name="city"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.zip
                            }
                            textcolor="#707070"
                            placeholder="Zipcode"
                            name="zip"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.state
                            }
                            textcolor="#707070"
                            placeholder="State"
                            name="state"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedBillingCustomerAddress === null
                                ? ""
                                : selectedBillingCustomerAddress.country
                            }
                            textcolor="#707070"
                            placeholder="Country"
                            name="country"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            id="customer_address_id"
                            value={selectedShippingCustomerAddress}
                            disabled={
                              customerAddress.length == 0 ? true : false
                            }
                            // name="address_book_id"
                            options={customerAddress}
                            getOptionLabel={(option) =>
                              // option.contact_name +
                              // ", " +
                              // option.contact_number +
                              // ", " +
                              option.addr1 +
                              ", " +
                              option.addr2 +
                              " " +
                              option.city +
                              " " +
                              option.zip +
                              ", " +
                              option.state +
                              ", " +
                              option.country
                            }
                            onChange={(e, value) => {
                              // console.log('value', value)
                              if (value != null) {
                                setSelectedShippingCustomerAddress({
                                  ...selectedShippingCustomerAddress,
                                  customer_address_id:
                                    value.customer_address_id,
                                  contact_name: value.contact_name,
                                  contact_number: value.contact_number,
                                  addr1: value.addr1,
                                  addr2: value.addr2,
                                  city: value.city,
                                  zip: value.zip,
                                  state: value.state,
                                  country: value.country,
                                });
                              } else {
                                setSelectedShippingCustomerAddress({
                                  ...selectedShippingCustomerAddress,
                                  customer_address_id: "",
                                  contact_name: "",
                                  contact_number: "",
                                  addr1: "",
                                  addr2: "",
                                  city: "",
                                  zip: "",
                                  state: "",
                                  country: "",
                                });
                              }
                            }}
                            style={{ width: "100%" }}
                            renderInput={(params) => (
                              <FormInput
                                {...params}
                                label="Shipping Address*"
                                // value={addressData.addr1}
                                textLabelColor="#000"
                                placeholder={
                                  customerAddress.length == 0
                                    ? "Please Choose Customer"
                                    : "Please Choose Shipping Address"
                                }
                                name="customer_address_id"
                                border="1px solid #c5c5c5"
                                padding="0.6rem 4rem 0.6rem 1rem"
                                bg={
                                  customerAddress.length == 0
                                    ? "#c5c5c5"
                                    : "#fff"
                                }
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password",
                                }}
                                // placeholder='Select Address'
                              />
                            )}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.contact_name
                            }
                            textcolor="#707070"
                            placeholder="Contact Name"
                            name="contact_name"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.contact_number
                            }
                            textcolor="#707070"
                            placeholder="Contact Number"
                            name="contact_number"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.addr1
                            }
                            textcolor="#707070"
                            placeholder="Address 1"
                            name="addr1"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.addr2
                            }
                            textcolor="#707070"
                            placeholder="Address 2"
                            name="addr2"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.city
                            }
                            textcolor="#707070"
                            placeholder="City"
                            name="city"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.zip
                            }
                            textcolor="#707070"
                            placeholder="Zipcode"
                            name="zip"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.state
                            }
                            textcolor="#707070"
                            placeholder="State"
                            name="state"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                          <FormInput
                            value={
                              selectedShippingCustomerAddress === null
                                ? ""
                                : selectedShippingCustomerAddress.country
                            }
                            textcolor="#707070"
                            placeholder="Country"
                            name="country"
                            bg="#c5c5c5"
                            border="1px solid #c5c5c5"
                            disabled
                            // onChange={handleChangeAddress}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <br />
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormInput
                          label="Class"
                          value={selectedClass}
                          textcolor="#707070"
                          placeholder="Class"
                          name="class"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          select
                          onChange={(e) => setSelectedClass(e.target.value)}
                        >
                          {classList != null &&
                            classList.map((res) => (
                              <MenuItem
                                value={res.class}
                                style={{ color: "#000" }}
                              >
                                {res.name}
                              </MenuItem>
                            ))}
                        </FormInput>
                        <FormInput
                          label="Merchandiser"
                          value={selectedMerchandiser}
                          textcolor="#707070"
                          placeholder="Class"
                          name="class"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          select
                          onChange={(e) =>
                            setSelectedMerchandiser(e.target.value)
                          }
                        >
                          <MenuItem value={0} style={{ color: "#000" }}>
                            Please Select a Merchansider
                          </MenuItem>
                          {merchandiser != null &&
                            merchandiser.map((res) => (
                              <MenuItem
                                value={res.internalid}
                                style={{ color: "#000" }}
                              >
                                {res.entityid}
                              </MenuItem>
                            ))}
                        </FormInput>
                        <FormInput
                          label="Sales Rep"
                          value={selectedRep}
                          textcolor="#707070"
                          placeholder="Sales Rep"
                          name="sales_rep"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          select
                          onChange={(e) => setSelectedRep(e.target.value)}
                        >
                          <MenuItem
                            value={0}
                            disabled
                            style={{ color: "#000" }}
                          >
                            None
                          </MenuItem>
                          {rep != null &&
                            rep.map((res) => (
                              <MenuItem
                                value={res.internalid}
                                style={{ color: "#000" }}
                              >
                                {res.entityid}
                              </MenuItem>
                            ))}
                        </FormInput>
                        <FormInput
                          label="Shipping Method*"
                          value={selectedShippingMethod.shipping_method_id}
                          textcolor="#707070"
                          placeholder="Shipping Method"
                          name="shipping_method_id"
                          border="1px solid #c5c5c5"
                          select
                          disabled={shippingMethod.length == 0 ? true : false}
                          bg={shippingMethod.length == 0 ? "#c5c5c5" : "#fff"}
                          // onChange={(e) => }
                        >
                          <MenuItem
                            value={0}
                            disabled
                            style={{ color: "#000" }}
                          >
                            Please Select Shipping Method
                          </MenuItem>
                          {shippingMethod.length != 0 &&
                            shippingMethod.map((res) => (
                              <MenuItem
                                value={res.shipping_method_id}
                                style={{ color: "#000" }}
                                onClick={() => handleChangeShippingMethod(res)}
                              >
                                {res.shippingmethod}
                              </MenuItem>
                            ))}
                        </FormInput>
                        {/* <p>{selectedShippingMethod.shipping_method_id}</p> */}
                        <FormInput
                          label="Shipping Carrier*"
                          value={selectedShippingMethod.shipping_carrier_id}
                          textcolor="#707070"
                          placeholder="Shipping Carrier"
                          name="shipping_carrier_id"
                          border="1px solid #c5c5c5"
                          select
                          // disabled={shippingCarrier.length == 0 ? true : false}
                          bg={shippingCarrier.length == 0 ? "#c5c5c5" : "#fff"}
                          // onChange={(e) => }
                        >
                          <MenuItem
                            value={0}
                            disabled
                            style={{ color: "#000" }}
                          >
                            Please Select Shipping Carrier
                          </MenuItem>
                          {shippingCarrier.length != 0 &&
                            shippingCarrier.map((res) => (
                              <MenuItem
                                value={res.shipping_carrier_id}
                                style={{ color: "#000" }}
                                onClick={() => handleChangeShippingCarrier(res)}
                              >
                                {res.shippingcarrier}
                              </MenuItem>
                            ))}
                        </FormInput>
                        {/* <p>{selectedShippingMethod.shipping_carrier_id}</p> */}

                        {/* <Paragraph margin=".4rem 0">Shipping Fee</Paragraph>
                                                <NumericFormat
                                                    value={orderFee.shipping_fee}
                                                    onChange={e => setOrderFee({
                                                        ...orderFee,
                                                        shipping_fee: e.target.value
                                                    })}
                                                    decimalScale={2}
                                                    thousandSeparator=","
                                                    customInput={TextField}
                                                    name="amount"
                                                    placeholder="Enter Your Withdraw Amount"
                                                    className={classes.theForm}
                                                // {...shippingFeeTextFieldProps}
                                                /> */}
                        <FormInput
                          label="Shipping Fee"
                          value={
                            orderFee.shipping_fee || copiedData.shipping_fee
                          }
                          textcolor="#707070"
                          placeholder="Shipping Fee"
                          name="shippingFee"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          // type="number"
                          onKeyPress={(event) => {
                            if (
                              event.target.value == "" &&
                              !/[1-9]/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          step="0.01"
                          inputProps={{ min: 0 }}
                          // onBlur={() =>
                          //   setOrderFee({
                          //     ...orderFee,
                          //     shipping_fee: parseFloat(
                          //       orderFee.shipping_fee
                          //     ).toFixed(2),
                          //   })
                          // }
                          // onKeyDown={(e) =>
                          //   e.key === "Enter" &&
                          //   setOrderFee({
                          //     ...orderFee,
                          //     shipping_fee: parseFloat(
                          //       orderFee.shipping_fee
                          //     ).toFixed(2),
                          //   })
                          // }
                          onChange={(e) => {
                            // console.log(e.target.value, orderFee.shipping_fee)
                            setOrderFee({
                              ...orderFee,
                              shipping_fee: e.target.value,
                              shipping_fee_custom: true,
                            });
                            clearTimeout(is_changing_shipping_fee.current);
                          }}
                        />
                        {/* <FormInput
                                                    label='Handling Fee'
                                                    value={orderFee.handling_fee}
                                                    textcolor='#707070'
                                                    placeholder='Handling Fee'
                                                    name='handlingfee'
                                                    bg='#c5c5c5'
                                                    border='1px solid #c5c5c5'
                                                    type='number'
                                                    inputProps={{ min: 0 }}
                                                    onChange={e => setOrderFee({
                                                        ...orderFee,
                                                        handling_fee: e.target.value
                                                    })}
                                                    disabled
                                                /> */}

                        <Paragraph margin=".4rem 0">Customer Po Form</Paragraph>
                        {/* <input
                          className="ori-fileinput"
                          type="file"
                          name="customerpo"
                          style={
                            {
                              // opacity: 0,
                              // top: "0",
                              // position: "absolute"
                            }
                          }
                          onChange={handleCaptureSingle}
                        /> */}
                        <div
                          {...customerpoDropzone.getRootProps({
                            className: "dropzone",
                          })}
                          style={dropzone}
                        >
                          <input {...customerpoDropzone.getInputProps()} />
                          <p>
                            Drag 'n' drop some files here, or click to select
                            files
                          </p>
                        </div>
                        <>
                          {files3 == [] ? (
                            <div {...customerpoDropzone.getRootProps({})}>
                              <input
                                {...customerpoDropzone.getInputProps()}
                                name="customerpo"
                              />
                            </div>
                          ) : (
                            <>
                              <div>{thumbs3}</div>
                              {/* {fileRejectionItems} */}
                            </>
                          )}
                        </>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        {/* <FormInput
                                                    label='Shipping Fee'
                                                    value={shippingFee}
                                                    textcolor='#707070'
                                                    placeholder='Shipping Fee'
                                                    name='shippingFee'
                                                    bg='#fff'
                                                    border='1px solid #c5c5c5'
                                                    type='number'
                                                    inputProps={{ min: 0 }}
                                                    onChange={e => setShippingFee(e.target.value)}
                                                /> */}
                        <FormInput
                          label="Deposit"
                          value={deposit}
                          textcolor="#707070"
                          placeholder="Deposit"
                          name="deposit"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          // type="number"

                          onKeyPress={(event) => {
                            if (
                              event.target.value == "" &&
                              !/[1-9]/.test(event.key)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          inputProps={{ min: 0 }}
                          onKeyDown={(e) =>
                            e.key === "Enter" &&
                            setDeposit(parseFloat(deposit).toFixed(2))
                          }
                          onBlur={() =>
                            setDeposit(parseFloat(deposit).toFixed(2))
                          }
                          onChange={(e) => setDeposit(e.target.value)}
                        />
                        <FormInput
                          label="Sales Remark"
                          value={remark.sales_remark || copiedData.sales_remark}
                          textcolor="#707070"
                          placeholder="Sales Remark"
                          r
                          name="sales_remark"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          onChange={handleChangeRemark}
                        />
                        <FormInput
                          label="Customer Remark"
                          value={
                            remark.customer_remark || copiedData.customer_remark
                          }
                          textcolor="#707070"
                          placeholder="Customer Remark"
                          name="customer_remark"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          onChange={handleChangeRemark}
                        />
                        <FormInput
                          label="Memo"
                          value={remark.memo || copiedData.memo}
                          textcolor="#707070"
                          placeholder="Memo"
                          name="memo"
                          bg="#fff"
                          border="1px solid #c5c5c5"
                          onChange={handleChangeRemark}
                        />
                        {/* <>
                          <FormInput
                            textcolor="#707070"
                            placeholder="Please Select Polybag"
                            name="polybag"
                            border="1px solid #c5c5c5"
                            select
                            label="Polybag"
                            onChange={handleChangePolybag}
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                          </FormInput>
                        </> */}
                        <FormControlLabel
                          sx={{ height: "70px" }}
                          control={
                            <Checkbox
                              checked={polybag === 1}
                              onChange={handleChangePolybag}
                              color="primary"
                            />
                          }
                          label="Polybag"
                        />

                        {/* {remark.bypasscl ? "Yes" : "No"} */}
                        {selectedCustomer !== null &&
                          selectedCustomer.paymenttype == "Credit" && (
                            <React.Fragment>
                              <Paragraph margin=".4rem 0">
                                Bypass Credit Limit
                              </Paragraph>
                              <Checkbox
                                onChange={() =>
                                  setRemark({
                                    ...remark,
                                    bypasscl: !remark.bypasscl,
                                  })
                                }
                                checked={remark.bypasscl}
                                sx={{
                                  padding: "0 .4rem 0 0",
                                  color: "#1A5386 ",
                                  "&.Mui-checked": {
                                    color: "#1A5386 ",
                                  },
                                }}
                              />
                              {remark.bypasscl ? "Yes" : "No"}
                            </React.Fragment>
                          )}

                        <Paragraph margin=".4rem 0">Attachment</Paragraph>
                        {/* <input
                          className="ori-fileinput"
                          type="file"
                          name="attachment"
                          onChange={handleCaptureSingle}
                          style={{ marginBottom: "1.6rem" }}
                        /> */}
                        <div
                          {...attachmentDropzone.getRootProps({
                            className: "dropzone",
                          })}
                          style={dropzone}
                        >
                          <input {...attachmentDropzone.getInputProps()} />
                          <p>
                            Drag 'n' drop some files here, or click to select
                            files
                          </p>
                        </div>
                        <>
                          {files2 == [] ? (
                            <div {...attachmentDropzone.getRootProps({})}>
                              <input
                                {...attachmentDropzone.getInputProps()}
                                name="attachment"
                              />
                            </div>
                          ) : (
                            <>
                              <div>{thumbs2}</div>
                              {/* {fileRejectionItems} */}
                            </>
                          )}
                        </>
                        <Paragraph margin=".4rem 0">
                          Upload Consignment Note
                        </Paragraph>
                        <div
                          {...getRootProps({ className: "dropzone" })}
                          style={dropzone}
                        >
                          <input {...getInputProps()} />
                          <p>
                            Drag 'n' drop some files here, or click to select
                            files
                          </p>
                        </div>
                        <>
                          {files == [] ? (
                            <div {...getRootProps({})}>
                              <input {...getInputProps()} />
                            </div>
                          ) : (
                            <>
                              <div>{thumbs}</div>
                              {/* {fileRejectionItems} */}
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <div
                            className={classes.theFlexHeader2}
                            ref={OrderProductRef}
                          >
                            <Paragraph color="#1A5386" size="22px" bold="600">
                              Product List
                            </Paragraph>
                            <div
                              className={classes.theFlexBtn}
                              style={{ marginBottom: "0" }}
                            >
                              {/* {productList.length == 0 &&
																	<a
																			style={{ border: 0 }}
																			className={classes.theCustomActionBtn}
																			onClick={() => handleBulkUpload()}
																	>
																			<Upload sx={{ color: '#1A5386' }} />
																			<Paragraph margin='0 0 0 .4rem'>
																					Upload Bulk Item
																			</Paragraph>
																	</a>
															} */}
                              {loadingItem ? (
                                <div style={{ margin: "auto" }}>
                                  <Loader
                                    type="bubble-loop"
                                    bgColor="#1A5386"
                                    size={50}
                                  />
                                </div>
                              ) : (
                                <a
                                  style={{
                                    border: 0,
                                    backgroundColor: "#1A5386",
                                    borderRadius: "10px",
                                  }}
                                  className={classes.theCustomActionBtn}
                                  onClick={() => handleCheckAction()}
                                >
                                  <AddCircle sx={{ color: "#fff" }} />
                                  <Paragraph
                                    size="16px"
                                    color="#fff"
                                    margin="0 0 0 .4rem"
                                  >
                                    Add Item
                                  </Paragraph>
                                </a>
                              )}
                            </div>
                          </div>
                          <br />
                          <div
                            style={{
                              borderBottom: "2px solid #707070",
                            }}
                          ></div>
                          <br />
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#fff" }}>
                                <TableRow>
                                  <TableCell
                                    style={{ borderRadius: "10px 0 0 10px" }}
                                    className={classes.theHeadTitle_}
                                  >
                                    Item Name
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle_}>
                                    Description
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle_}>
                                    Attributes
                                  </TableCell>
                                  {/* <TableCell className={classes.theHeadTitle_}>
                                                                        Size
                                                                    </TableCell>
                                                                    <TableCell className={classes.theHeadTitle_}>
                                                                        Price Level
                                                                    </TableCell> */}
                                  <TableCell className={classes.theHeadTitle_}>
                                    Price
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.theHeadTitle_}
                                  >
                                    Discount Amount
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={classes.theHeadTitle_}
                                  >
                                    Quantity
                                  </TableCell>
                                  <TableCell
                                    className={classes.theHeadTitle_}
                                    sx={{ textAlign: "right" }}
                                  >
                                    Total Price
                                  </TableCell>
                                  <TableCell
                                    style={{ borderRadius: "0 10px 10px 0" }}
                                    className={classes.theHeadTitle_}
                                  >
                                    <MoreVert sx={{ color: "#000" }} />
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {productList.length > 0 &&
                                  productList.map((productRest, index) => (
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        {productRest.itemname != "" &&
                                        productRest.itemname != null
                                          ? productRest.itemname
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                          width: "20%",
                                        }}
                                      >
                                        <pre
                                          style={{
                                            margin: 0,
                                            fontFamily:
                                              "Roboto,Helvetica, Arial",
                                            whiteSpace: "pre-line",
                                          }}
                                        >
                                          {productRest.description != "" &&
                                          productRest.description != null
                                            ? productRest.description
                                            : productRest.displayname}
                                        </pre>

                                        {productRest.displayname == "" && (
                                          <div
                                            onClick={() =>
                                              handleOpenAddIndexProduct(
                                                productRest
                                              )
                                            }
                                          >
                                            <Paragraph
                                              textDecoration="underline"
                                              margin="0"
                                              color="#1A5386"
                                            >
                                              Edit Description
                                            </Paragraph>
                                          </div>
                                        )}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        Clr:{" "}
                                        {productRest.color != "" &&
                                        productRest.color != null
                                          ? productRest.color
                                          : "-"}
                                        <div>
                                          Sz:{" "}
                                          {productRest.size != "" &&
                                          productRest.size != null
                                            ? productRest.size
                                            : "-"}
                                        </div>
                                      </TableCell>
                                      {/* <TableCell style={{ background: index % 2 == 0 ? "#E0F0F7" : "#fff" }}>
                                                                            {productRest.size}
                                                                        </TableCell> */}
                                      {/* <TableCell style={{ background: index % 2 == 0 ? "#E0F0F7" : "#fff" }}>
                                                                            {productRest.pricelevel}
                                                                        </TableCell> */}
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        {parseFloat(
                                          productRest.given_price
                                        ).toFixed(4)}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "60%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <FormInput
                                            className="right"
                                            border="1px solid #d7d7d7"
                                            type="number"
                                            // onKeyPress={(event) => {
                                            //   if (!/[0-9\.]/.test(event.key)) {
                                            //     event.preventDefault();
                                            //   }
                                            // }}
                                            // inputProps={{
                                            //   min: 0,
                                            // }}
                                            bg="#fff"
                                            // value={
                                            //   productRest.given_discount !==
                                            //   0 && productRest.given_discount
                                            // }
                                            value={
                                              !isNaN(productRest.given_discount)
                                                ? productRest.given_discount
                                                : ""
                                            }
                                            // value={
                                            //   productRest.given_discount !== 0 && !isNaN(productRest.given_discount) ? productRest.given_discount : ''
                                            // }

                                            mb="0"
                                            onChange={(e) =>
                                              handleChangeDiscountText(index, e)
                                            }
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <RemoveCircle
                                            sx={{
                                              color: "#1A5386",
                                              marginRight: "10px",
                                            }}
                                            onClick={() =>
                                              handleChangeQty(index, -1)
                                            }
                                          />
                                          <div
                                            style={{
                                              width: "40%",
                                            }}
                                          >
                                            <FormInput
                                              border="1px solid #d7d7d7"
                                              className="right"
                                              // type="number"
                                              onKeyPress={(event) => {
                                                if (
                                                  event.target.value === "" &&
                                                  !/^[0-9]*$/.test(event.key) &&
                                                  event.key !== "-"
                                                ) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{
                                                min: 1,
                                                max: productRest.quantityavailable,
                                              }}
                                              bg="#fff"
                                              value={productRest.quantity}
                                              mb="0"
                                              onChange={(e) =>
                                                handleChangeQtyText(index, e)
                                              }
                                            />
                                          </div>

                                          <AddCircle
                                            onClick={() =>
                                              handleChangeQty(index, 1)
                                            }
                                            sx={{
                                              color: "#1A5386",
                                              marginLeft: "10px",
                                            }}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                          textAlign: "right",
                                        }}
                                      >
                                        {/* {(
                                          parseFloat(productRest.given_price) *
                                          parseFloat(productRest.quantity)
                                        ).toFixed(2)} */}
                                        {parseFloat(
                                          productRest.given_subtotal
                                        ).toFixed(2)}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          background:
                                            index % 2 == 0 ? "#E0F0F7" : "#fff",
                                        }}
                                      >
                                        <Close
                                          sx={{ color: "#C52626" }}
                                          onClick={() =>
                                            handleRemoveItem(index)
                                          }
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <br />
                          <div
                            style={{
                              borderBottom: "2px solid #E0F0F7",
                            }}
                          ></div>
                          <br />
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">Amount:</Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderFee.total_amount}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Discount Amount:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {/* {parseFloat(
                                          discountData.discountvalue
                                        ).toFixed(2)} */}
                                      {orderFee.discountamount}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Shipping Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderFee.shipping_fee}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Handling Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderFee.handling_fee}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #E0F0F7",
                                }}
                              ></div>
                              <br />
                              {loadingCalculate ? (
                                <div style={{}}>
                                  <Loader
                                    type="bubble-loop"
                                    bgColor="#1A5386"
                                    size={50}
                                  />
                                </div>
                              ) : (
                                <div className={classes.theTotal}>
                                  <Grid container spacing={3}>
                                    {billtype != null && (
                                      <React.Fragment>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph size="14px">
                                            {billtype}:
                                          </Paragraph>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Paragraph
                                            size="14px"
                                            bold="600"
                                            style={{ textAlign: "right" }}
                                          >
                                            {orderFee.tax_fee}
                                          </Paragraph>
                                        </Grid>
                                      </React.Fragment>
                                    )}
                                    {orderFee.total_amount != 0 && (
                                      <React.Fragment></React.Fragment>
                                    )}
                                    <Grid item xs={6} sm={6} md={6}>
                                      <Paragraph size="14px">Total:</Paragraph>
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={6}>
                                      <Paragraph
                                        size="14px"
                                        bold="600"
                                        style={{ textAlign: "right" }}
                                      >
                                        {orderFee.final_amount}
                                      </Paragraph>
                                    </Grid>
                                  </Grid>
                                </div>
                              )}
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #E0F0F7",
                                }}
                              ></div>
                              <br />
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph bold="bold" size="14px">
                                      Deposit:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="bold"
                                      style={{ textAlign: "right" }}
                                    >
                                      {parseFloat(deposit).toFixed(2)}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                  </div>
                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    {loadingAdd ? (
                      <div style={{}}>
                        <Loader
                          type="bubble-loop"
                          bgColor="#1A5386"
                          size={50}
                        />
                      </div>
                    ) : (
                      <a
                        className={classes.theAddCustomActionBtnFill}
                        onClick={() => handleSubmitOrder()}
                      >
                        {/* <CheckCircleOutline sx={{ color: "#fff" }} /> */}
                        <Paragraph margin="0 0 0 .4rem">Create Order</Paragraph>
                      </a>
                    )}
                  </div>

                  <Dialog
                    onClose={handleCloseAdd}
                    open={openAdd}
                    fullWidth="true"
                    maxWidth="sm"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Add Address
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Name"
                            value={addressAddData.contact_name}
                            textLabelColor="#000"
                            placeholder="Contact Name"
                            name="contact_name"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Contact Number"
                            value={addressAddData.contact_number}
                            textLabelColor="#000"
                            placeholder="Contact Number"
                            name="contact_number"
                            border="1px solid #c5c5c5"
                            type="number"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 1"
                            value={addressAddData.addr1}
                            textLabelColor="#000"
                            placeholder="Address 1"
                            name="addr1"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Address 2"
                            value={addressAddData.addr2}
                            textLabelColor="#000"
                            placeholder="Address 2"
                            name="addr2"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="City"
                            value={addressAddData.city}
                            textLabelColor="#000"
                            placeholder="City"
                            name="city"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Zipcode"
                            value={addressAddData.zip}
                            textLabelColor="#000"
                            placeholder="Zipcode"
                            name="zip"
                            border={
                              zipStatus
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                            mb="0"
                            onChange={handleChangeAddAddress}
                          />
                          {zipStatus && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="State"
                            value={addressAddData.state}
                            textLabelColor="#000"
                            placeholder="State"
                            name="state"
                            border={
                              zipStatus
                                ? "1px solid #C52626"
                                : "1px solid #c5c5c5"
                            }
                            mb="0"
                            onChange={handleChangeAddAddress}
                            select
                          >
                            <MenuItem
                              value={0}
                              disabled
                              style={{ color: "#000" }}
                            >
                              Please Select State
                            </MenuItem>
                            {stateData.length != 0 &&
                              stateData.map((res) => (
                                <MenuItem
                                  value={res.name}
                                  style={{ color: "#000" }}
                                  // onClick={handleChangeAddress}
                                >
                                  {res.name}
                                </MenuItem>
                              ))}
                          </FormInput>
                          {zipStatus && (
                            <Paragraph margin="4px 0 0" color="#C52626">
                              Warning
                            </Paragraph>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={6}>
                          <FormInput
                            label="Country"
                            value={addressAddData.country}
                            textLabelColor="#000"
                            placeholder="Country"
                            name="country"
                            border="1px solid #c5c5c5"
                            mb="0"
                            onChange={handleChangeAddAddress}
                            select
                          >
                            <MenuItem
                              value={0}
                              disabled
                              style={{ color: "#000" }}
                            >
                              Please Select Country
                            </MenuItem>
                            {countryData.length != 0 &&
                              countryData.map((res) => (
                                <MenuItem
                                  value={res.name}
                                  style={{ color: "#000" }}
                                  // onClick={handleChangeAddAddress}
                                >
                                  {res.name}
                                </MenuItem>
                              ))}
                          </FormInput>
                        </Grid>
                      </Grid>
                      <br />
                      <Button
                        onClick={() => handleAddAddress()}
                        label="Add"
                        color="#fff"
                        bg="#1A5386"
                        size="18px"
                        pd="10px"
                        br="5px"
                        style={{ margin: "10px 0" }}
                      />
                    </DialogContent>
                  </Dialog>

                  {selectedIndexProduct != null && (
                    <Dialog
                      onClose={handleCloseIndexProduct}
                      open={openEditDesc}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Edit Description
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormInput
                              value={
                                selectedIndexProduct !== null &&
                                decodeURIComponent(
                                  selectedIndexProduct.description
                                )
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="1rem"
                              multiline
                              minRows={4}
                              onChange={handleChangeIndexProduct}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          onClick={() => handleCloseIndexProduct()}
                          label="Save"
                          color="#fff"
                          bg="#1A5386"
                          size="18px"
                          pd="10px"
                          br="5px"
                          style={{ marginBottom: "10px" }}
                        />
                      </DialogContent>
                    </Dialog>
                  )}
                </Section>
              }
            />
          ) : (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => {
                        setPage("order");
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#1A5386"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Product List
                      </Paragraph>

                      {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
													<a
															className={classes.theCustomActionBtnFill}
													// onClick={() => handleOpenStockMove()}
													>
															<CheckCircleOutline sx={{ color: "#fff" }} />
															<Paragraph margin="0 0 0 .4rem">Approve</Paragraph>
													</a>
													<a
															className={classes.theCustomActionBtnFill_}
													// onClick={() => handleOpenStockMove()}
													>
															<DoDisturbAlt sx={{ color: "#fff" }} />
															<Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
													</a>
											</div> */}
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <div className={classes.theFlexAction}>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            name="search"
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={handleSearch}
                            value={searchKey}
                          />
                        </div>
                        <div
                          className={classes.theWx}
                          style={{ margin: "0 20px 0 0", width: "100%" }}
                        >
                          <FormInputNoLabel
                            name="color"
                            placeholder="Search"
                            border="1px solid #d7d7d7"
                            br="6px"
                            onChange={(e) => setColorSort(e.target.value)}
                            value={colorSort}
                            select
                          >
                            <MenuItem value="false">Select a Color</MenuItem>
                            {colorData != null &&
                              colorData.map((res) => (
                                <MenuItem
                                  value={res.colorname}
                                  style={{ color: "#000" }}
                                >
                                  {res.colorname}
                                </MenuItem>
                              ))}
                          </FormInputNoLabel>
                        </div>
                      </div>
                      {/* <div className={classes.theFlex_}>
                        <div
                          className={
                            viewType == "grid"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("grid")}
                        >
                          <GridView
                            sx={{
                              color: viewType == "grid" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                        <div
                          className={
                            viewType == "list"
                              ? classes.theIconButtonSelected
                              : classes.theIconButton
                          }
                          onClick={() => setViewType("list")}
                        >
                          <List
                            sx={{
                              color: viewType == "list" ? "#fff" : "#1A5386",
                              fontSize: "1.2rem",
                            }}
                          />
                        </div>
                      </div> */}
                    </div>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#1A5386" }}>
                                <TableRow>
                                  <TableCell
                                    style={{ borderRadius: "10px 0 0 10px" }}
                                    className={classes.theHeadTitle}
                                  >
                                    Item Name
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Size
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Color
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Quantity
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Price
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Sale Unit
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Brand
                                  </TableCell>
                                  <TableCell
                                    style={{ borderRadius: "0 10px 10px 0" }}
                                    className={classes.theHeadTitle}
                                  >
                                    <MoreVert sx={{ color: "#fff" }} />
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {inventory != null &&
                                  inventory
                                    .slice(pageNum * 10, pageNum * 10 + 10)
                                    .map((item, index) => {
                                      return (
                                        <React.Fragment>
                                          <TableRow>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "25%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.itemname != "" &&
                                              item.itemname != null
                                                ? item.itemname
                                                : "-"}
                                              <div>
                                                {item.displayname != "" &&
                                                item.displayname != null
                                                  ? item.displayname
                                                  : "-"}
                                              </div>
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.size != "" &&
                                              item.size != null
                                                ? item.size
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.colorname != "" &&
                                              item.colorname != null
                                                ? item.colorname
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "15%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              -
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.price != "" &&
                                              item.price != null
                                                ? parseFloat(item.price).toFixed(2)
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.saleunit != "" &&
                                              item.saleunit != null
                                                ? item.saleunit
                                                : "-"}
                                            </TableCell>

                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                              }}
                                            >
                                              {item.brand != "" &&
                                              item.brand != null
                                                ? item.brand
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              className={classes.theDetailRow}
                                              style={{
                                                width: "10%",
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                item.type === "Matrix Item" ||
                                                item.type == "Dropship Item"
                                                  ? handleChangeTable(item)
                                                  : item.inactive == 1
                                                  ? toast(
                                                      "This item is unavailable"
                                                    )
                                                  : handleOpen(item)
                                              }
                                            >
                                              {item.type === "Matrix Item" ||
                                              item.type === "Dropship Item" ? (
                                                item.openTable ? (
                                                  <ArrowCircleUp
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                ) : (
                                                  <ArrowCircleDown
                                                    sx={{ color: "#1A5386" }}
                                                  />
                                                )
                                              ) : (
                                                <AddCircle
                                                  sx={{
                                                    color:
                                                      item.inactive == 1
                                                        ? "#9e9e9e"
                                                        : "#1A5386",
                                                  }}
                                                />
                                              )}
                                            </TableCell>
                                          </TableRow>
                                          {(item.type === "Matrix Item" ||
                                            item.type == "Dropship Item") && (
                                            <TableRow>
                                              <TableCell
                                                className={
                                                  classes.theDetailOpen
                                                }
                                                colSpan={8}
                                              >
                                                <Collapse
                                                  // in={item.openTable}
                                                  in={open[item.item_id]}
                                                  timeout="auto"
                                                  unmountOnExit
                                                >
                                                  {viewType == "list" ? (
                                                    <Table>
                                                      {item.children.map(
                                                        (res, resindex) => (
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell
                                                                style={{
                                                                  width: "25%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                  // display: "flex",
                                                                  // alignItems: "center"
                                                                }}
                                                              >
                                                                <SubdirectoryArrowRight
                                                                  sx={{
                                                                    color:
                                                                      "#1A5386",
                                                                    // marginTop: "20px"
                                                                  }}
                                                                />
                                                                {res.itemname}
                                                                <div>
                                                                  {
                                                                    res.displayname
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.size}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.colorname}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "15%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                On Hand:{" "}
                                                                {
                                                                  res.quantityonhand
                                                                }
                                                                <div>
                                                                  Free to use:{" "}
                                                                  {
                                                                    res.quantityavailable
                                                                  }
                                                                </div>
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {
                                                                  selectedCustomer.currency
                                                                }{" "}
                                                                {res.price != "" &&
                                                                res.price != null
                                                                  ? parseFloat(res.price).toFixed(2)
                                                                  : "0.00"}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.saleunit}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {res.brand !=
                                                                  "" &&
                                                                res.brand !=
                                                                  null
                                                                  ? res.brand
                                                                  : "-"}
                                                              </TableCell>
                                                              <TableCell
                                                                style={{
                                                                  width: "10%",
                                                                  background:
                                                                    index % 2 ==
                                                                    0
                                                                      ? "#E0F0F7"
                                                                      : "#fff",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  res.price ==
                                                                    0 ||
                                                                  res.inactive ==
                                                                    1
                                                                    ? toast(
                                                                        "This item is unavailable"
                                                                      )
                                                                    : handleOpen(
                                                                        res
                                                                      )
                                                                }
                                                              >
                                                                <AddCircle
                                                                  sx={{
                                                                    color:
                                                                      item.inactive ==
                                                                      1
                                                                        ? "#9e9e9e"
                                                                        : "#1A5386",
                                                                  }}
                                                                />
                                                              </TableCell>
                                                            </TableRow>
                                                          </TableBody>
                                                        )
                                                      )}
                                                    </Table>
                                                  ) : (
                                                    <div
                                                      className={
                                                        index % 2 == 0
                                                          ? classes.theGridOdd
                                                          : classes.theGridEven
                                                      }
                                                    >
                                                      {item.children_grid.map(
                                                        (
                                                          resCGrid,
                                                          resindex
                                                        ) => (
                                                          <div
                                                            className={
                                                              classes.theGFlex
                                                            }
                                                          >
                                                            <div
                                                              className={
                                                                classes.theGFName
                                                              }
                                                            >
                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .color
                                                                }
                                                              </Paragraph>

                                                              <Paragraph
                                                                color="#000"
                                                                bold="600"
                                                                size="0.875rem"
                                                              >
                                                                {
                                                                  resCGrid[0]
                                                                    .cataloguedescription
                                                                }
                                                              </Paragraph>
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.theGFItem
                                                              }
                                                            >
                                                              {resCGrid.map(
                                                                (
                                                                  resGGM,
                                                                  resindex
                                                                ) => (
                                                                  <div
                                                                    className={
                                                                      classes.theGFIBox
                                                                    }
                                                                  >
                                                                    <Paragraph
                                                                      bold="500"
                                                                      margin="0 0 .4rem 0"
                                                                      center
                                                                    >
                                                                      {
                                                                        resGGM.size
                                                                      }
                                                                    </Paragraph>

                                                                    <FormInput
                                                                      border="1px solid #d7d7d7"
                                                                      name="quantity"
                                                                      // onKeyDown={(e) => e.key === 'Enter' && handleChangeGrid(e, index)}
                                                                      // onBlur={(
                                                                      //   e
                                                                      // ) =>
                                                                      //   handleChangeGrid(
                                                                      //     e,
                                                                      //     index
                                                                      //   )
                                                                      // }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index,
                                                                          item
                                                                        )
                                                                      }
                                                                      className="customTextField"
                                                                      id={
                                                                        resGGM.internalid +
                                                                        "_" +
                                                                        resGGM.hscode +
                                                                        "_" +
                                                                        resGGM.itemname +
                                                                        "_" +
                                                                        resGGM.price +
                                                                        "_" +
                                                                        resGGM.type +
                                                                        "_" +
                                                                        resGGM.color +
                                                                        "_" +
                                                                        resGGM.quantityavailable +
                                                                        "_" +
                                                                        resGGM.size
                                                                      }
                                                                      center
                                                                      onKeyPress={(
                                                                        event
                                                                      ) => {
                                                                        if (
                                                                          !/[0-9]/.test(
                                                                            event.key
                                                                          )
                                                                        ) {
                                                                          event.preventDefault();
                                                                        }
                                                                      }}
                                                                      inputProps={{
                                                                        min: 1,
                                                                        max:
                                                                          item.type ==
                                                                          "Matrix Item"
                                                                            ? resGGM.quantityavailable
                                                                            : 9999999,
                                                                      }}
                                                                      bg={
                                                                        item.type !=
                                                                          "Dropship Item" &&
                                                                        (resGGM.price ==
                                                                          0 ||
                                                                          resGGM.inactive ==
                                                                            1 ||
                                                                          resGGM.quantityavailable <=
                                                                            0)
                                                                          ? "#d7d7d7"
                                                                          : "#fff"
                                                                      }
                                                                      disabled={
                                                                        item.type !=
                                                                          "Dropship Item" &&
                                                                        (resGGM.price ==
                                                                          0 ||
                                                                          resGGM.inactive ==
                                                                            1 ||
                                                                          resGGM.quantityavailable <=
                                                                            0)
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />

                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      bold="600"
                                                                      center
                                                                      color={
                                                                        resGGM.bestbuy ==
                                                                        1
                                                                          ? "#FF00FF"
                                                                          : "#707070"
                                                                      }
                                                                    >
                                                                      {
                                                                        selectedCustomer.currency
                                                                      }{" "}
                                                                      {resGGM.price != "" &&
                                                                      resGGM.price != null
                                                                        ? parseFloat(resGGM.price).toFixed(2)
                                                                        : "0.00"}
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      On Hand:{" "}
                                                                      {
                                                                        resGGM.quantityonhand
                                                                      }
                                                                    </Paragraph>
                                                                    <Paragraph
                                                                      style={{
                                                                        fontStyle:
                                                                          "italic",
                                                                      }}
                                                                      margin="0"
                                                                      center
                                                                      color="#C52626"
                                                                    >
                                                                      Free to
                                                                      use:{" "}
                                                                      {
                                                                        resGGM.quantityavailable
                                                                      }
                                                                    </Paragraph>
                                                                    <div
                                                                      onClick={() =>
                                                                        resGGM.price ==
                                                                          0 ||
                                                                        resGGM.inactive ==
                                                                          1
                                                                          ? toast(
                                                                              "This item is unavailable"
                                                                            )
                                                                          : handleOpenAddDesc(
                                                                              resGGM
                                                                            )
                                                                      }
                                                                    >
                                                                      <Paragraph
                                                                        textDecoration="underline"
                                                                        margin="0"
                                                                        center
                                                                        color={
                                                                          resGGM.price ==
                                                                            0 ||
                                                                          resGGM.inactive ==
                                                                            1
                                                                            ? "#9e9e9e"
                                                                            : "#1A5386"
                                                                        }
                                                                      >
                                                                        + Add
                                                                        Description
                                                                      </Paragraph>
                                                                    </div>
                                                                    <input
                                                                      value={
                                                                        resGGM.internalid
                                                                      }
                                                                      name="id"
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        handleChangeGrid(
                                                                          e,
                                                                          index,
                                                                          item
                                                                        )
                                                                      }
                                                                      type="hidden"
                                                                    />
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  )}
                                                </Collapse>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          <div
                            style={{
                              borderTop: "1px solid #707070",
                              borderBottom: "1px solid #707070",
                              margin: "1rem 0 0",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                            }}
                          >
                            <TablePagination
                              // variant="outlined"
                              color="primary"
                              page={pageNum}
                              onPageChange={handleChangePage}
                              count={totalList}
                              // defaultPage={pageList}
                              rowsPerPage={10}
                              rowsPerPageOptions={[10]}
                              // count={10}
                            />
                          </div>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                    <br />
                  </div>
                  {selectedItem != null && (
                    <Dialog
                      onClose={handleClose}
                      open={open}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph
                          color="#1A5386"
                          bold="600"
                          size="24px"
                          center
                        >
                          Enter Detail
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <div className={classes.theQuantityBox}>
                          <RemoveCircle
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                            onClick={() =>
                              selectedItem.quantity > 1 &&
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) - 1,
                              })
                            }
                          />
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null &&
                                parseInt(selectedItem.quantity)
                              }
                              textLabelColor="#000"
                              name="quantity"
                              border="1px solid #c5c5c5"
                              mb="0"
                              // onKeyPress={(event) => {
                              //   if (!/[0-9]/.test(event.key)) {
                              //     event.preventDefault();
                              //   }
                              // }}
                              // type="number"
                              onKeyPress={(event) => {
                                if (
                                  event.target.value === "" &&
                                  !/-?[0-9]/.test(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              inputProps={{
                                min: 1,
                                max: selectedItem.quantityavailable,
                              }}
                              center
                              onChange={handleChangeProduct2}
                            />
                          </div>
                          <AddCircle
                            onClick={() =>
                              setSelectedItem({
                                ...selectedItem,
                                quantity: parseInt(selectedItem.quantity) + 1,
                              })
                            }
                            sx={{ fontSize: "2rem", color: "#1A5386" }}
                          />
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null && selectedItem.price
                              }
                              textLabelColor="#000"
                              disabled={
                                selectedItem != null &&
                                selectedItem.type != "Matrix Item" &&
                                selectedItem.type != "Dropship Item"
                                  ? false
                                  : true
                              }
                              name="price"
                              placeholder="Price"
                              // type="number"

                              onKeyPress={(event) => {
                                if (
                                  event.target.value == "" &&
                                  !/[0-9]/.test(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              inputProps={{ min: 0 }}
                              border="1px solid #c5c5c5"
                              mb="0"
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <FormInput
                              value={
                                selectedItem !== null &&
                                selectedItem.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="0"
                              multiline
                              minRows={4}
                              onChange={handleChangeProduct}
                            />
                          </div>
                        </div>
                        <div className={classes.theQuantityBox}>
                          <div className={classes.theQuantityField}>
                            <Button
                              onClick={() =>
                                (selectedItem.type == "Matrix Item" ||
                                  selectedItem.type == "Dropship Item") &&
                                selectedItem.price == 0
                                  ? toast("Invalid Price")
                                  : addProduct()
                              }
                              label="Confirm"
                              color="#fff"
                              bg={
                                (selectedItem.type == "Matrix Item" ||
                                  selectedItem.type == "Dropship Item") &&
                                selectedItem.price == 0
                                  ? "#c5c5c5"
                                  : "#1A5386"
                              }
                              size="18px"
                              pd="10px"
                              br="5px"
                              style={{ marginBottom: "10px" }}
                            />
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  )}

                  {selectedGrid != null && (
                    <Dialog
                      onClose={handleCloseAddDesc}
                      open={openAddDesc}
                      fullWidth="true"
                      maxWidth="sm"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          Add Description
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormInput
                              value={
                                selectedGrid !== null &&
                                selectedGrid.description
                              }
                              textLabelColor="#000"
                              name="description"
                              placeholder="Description"
                              border="1px solid #c5c5c5"
                              mb="1rem"
                              multiline
                              minRows={4}
                              onChange={handleChangeDesc}
                            />
                          </Grid>
                        </Grid>
                        <Button
                          onClick={() => handleAddDEsc()}
                          label="Add"
                          color="#fff"
                          bg="#1A5386"
                          size="18px"
                          pd="10px"
                          br="5px"
                          style={{ marginBottom: "10px" }}
                        />
                      </DialogContent>
                    </Dialog>
                  )}

                  <div
                    className={classes.theFloatCart}
                    style={{
                      display: displayFloat ? "block" : "none",
                    }}
                  >
                    <div className={classes.theFCHeader}>
                      <Paragraph color="#fff" bold="600" size="14px">
                        Added Product List
                      </Paragraph>
                    </div>
                    <div className={classes.theFCTable}>
                      <TableContainer style={{ maxHeight: 300 }}>
                        <Table>
                          <TableHead style={{ backgroundColor: "#fff" }}>
                            <TableRow>
                              <TableCell className={classes.theCartTitle}>
                                Item Name
                              </TableCell>
                              <TableCell className={classes.theCartTitle}>
                                Quantity
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {productList.length > 0 &&
                              productList.map((productRest, index) => (
                                <TableRow>
                                  <TableCell
                                    style={{
                                      width: "80%",
                                    }}
                                  >
                                    {productRest.itemname != "" &&
                                    productRest.itemname != null
                                      ? productRest.itemname
                                      : "-"}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "20%",
                                    }}
                                  >
                                    {productRest.quantity}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <div className={classes.theFCFooter}>
                      <div
                        className={classes.theCheckoutBtn}
                        style={{ margin: "0 10px 0 0" }}
                      >
                        <Button
                          label="Back"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            setPage("order");
                            setTimeout(() => {
                              OrderProductRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 300);
                            // setPage('order');
                            // OrderProductRef.current.scrollIntoView({ behavior: "smooth" })
                          }}
                        />
                      </div>
                      <div className={classes.theCheckoutBtn}>
                        <Button
                          label="Proceed to cart"
                          color="#FFF"
                          bg="#1A5386"
                          br="4px"
                          pd=".4rem 1.2rem"
                          size="14px"
                          onClick={() => {
                            setPage("order");
                            calculateCart();
                            setTimeout(() => {
                              OrderProductRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 300);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={classes.theShirtIcon}
                    onClick={() => setDisplayFloat(!displayFloat)}
                  >
                    <div className={classes.theSIImage}>
                      <img src={ShirtIcon} />
                    </div>
                    <div
                      style={{
                        backgroundColor: "#C52626",
                        width: "25px",
                        height: "25px",
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                      }}
                    >
                      <Paragraph color="#fff" bold="600" size="12px">
                        {productList.length}
                      </Paragraph>
                    </div>
                  </div>
                </Section>
              }
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
}
